import Breadcrumb from "Components/Common/Breadcrumb";
import React from "react";
import { Container } from "reactstrap";

function CardAcquirance() {
  return (
    <React.Fragment>
      <div className="page-content">
        <Container fluid>
          <Breadcrumb
            title="Card Acquirance"
            breadcrumbItem="Card Acquirance"
          />
          <h4>Card Acquirance</h4>
        </Container>
      </div>
    </React.Fragment>
  );
}

export default CardAcquirance;
